import { ZOOM_STATE } from '../../constants/system.keys';
import {
  ADD_VIEWING_CAMERA_SERIAL,
  ADD_VIEWING_RECORD_ID,
  REMOVE_VIEWING_CAMERA_SERIAL,
  REMOVE_VIEWING_RECORD_ID,
  RESET_RECOVERY_CAMERA_PAGE,
  RESET_RECOVERY_LIVE_PAGE,
  RESET_RECOVERY_SHARE_PAGE,
  UPDATE_RECOVERY_CAMERA_PAGE,
  UPDATE_RECOVERY_CAMERA_TAB_OF_SHARE_PAGE,
  UPDATE_RECOVERY_GROUP_CAMERA_TAB_OF_SHARE_PAGE,
  UPDATE_RECOVERY_HISTORY_EVENT_OF_CAMERA_PAGE,
  UPDATE_RECOVERY_LIVE_PAGE,
  UPDATE_RECOVERY_MEMBER_TAB_OF_SHARE_PAGE,
  UPDATE_RECOVERY_SHARE_PAGE,
} from './action';

export const RECOVERY_KEY = 'recovery';

const initialState = {
  livePage: {
    selectedGroup: null,
    selectedCamera: null,
    viewingCameraSerials: [],
    sidebarMode: 'list',
    searchKeyword: '',
    pagination: {
      page: 1,
      size: 9,
      quality: ZOOM_STATE.THREE,
      grid: [3, 3],
    },
    autoSwitchPageSeconds: null,
    autoPlay: false,
    expandedTreeGroupIds: null,
  },
  cameraPage: {
    selectedGroup: null,
    selectedCamera: null,
    sidebarMode: 'list',
    selectedDate: null,
    selectedTimes: null,
    scrollPosition: 0,
    analyticsVisibile: false,
    searchModalVisible: false,
    searchVideoTag: '',
    listStorageFileByTag: [],
    visibleModalAddCamera: false,
    rtspAddMethod: null,
    activeAddCameraTab: '1',
    expandedTreeGroupIds: null,
    visibleCameraDetail: null,
    cameraToEdit: null,
    cameraToUpdateStream: null,
    cameraToHistoryEvent: null,
    historyEvent: {
      camera: null,
      filterType: 'camera_disconnection_session',
    },
    cameraToService: null,
    viewingRecords: [],
    searchCameraKeyword: '',
    pagination: {
      page: 1,
      size: 15,
    },
  },
  sharePage: {
    activeTab: 0,
    cameraTab: {
      selectedGroup: null,
      searchCamera: '',
      rowSelection: {
        row: null,
        keys: [],
      },
      pagination: {
        size: 'small',
        current: 1,
        pageSize: 10,
        total: 0,
      },
    },
    groupCameraTab: {
      searchGroupCamera: '',
      selectedGroup: {
        keys: [],
        rows: [],
      },
    },
    memberTab: {
      searchMember: '',
      selectedMember: [],
    },
  },
};
const internalReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_RECOVERY_LIVE_PAGE:
      return {
        ...state,
        livePage: {
          ...state.livePage,
          ...action.payload,
        },
      };

    case ADD_VIEWING_CAMERA_SERIAL: {
      const viewingCameraSerials = state.livePage.viewingCameraSerials || [];
      const serial = action.payload;

      if (!serial || viewingCameraSerials.includes(serial)) {
        return state;
      }

      return {
        ...state,
        livePage: {
          ...state.livePage,
          viewingCameraSerials: [...viewingCameraSerials, serial],
        },
      };
    }

    case REMOVE_VIEWING_CAMERA_SERIAL: {
      const viewingCameraSerials = state.livePage.viewingCameraSerials || [];
      const serial = action.payload;

      if (!serial || !viewingCameraSerials.includes(serial)) {
        return state;
      }

      return {
        ...state,
        livePage: {
          ...state.livePage,
          viewingCameraSerials: viewingCameraSerials.filter(
            (item) => item !== serial,
          ),
        },
      };
    }

    case RESET_RECOVERY_LIVE_PAGE:
      return {
        ...state,
        livePage: initialState.livePage,
      };

    // Camera:
    case UPDATE_RECOVERY_CAMERA_PAGE:
      return {
        ...state,
        cameraPage: {
          ...state.cameraPage,
          ...action.payload,
        },
      };

    case UPDATE_RECOVERY_HISTORY_EVENT_OF_CAMERA_PAGE:
      return {
        ...state,
        cameraPage: {
          ...state.cameraPage,
          historyEvent: {
            ...state.cameraPage.historyEvent,
            ...action.payload,
          },
        },
      };

    case RESET_RECOVERY_CAMERA_PAGE:
      return {
        ...state,
        cameraPage: initialState.cameraPage,
      };

    case ADD_VIEWING_RECORD_ID: {
      const viewingRecords = state.cameraPage.viewingRecords || [];
      const recordId = action.payload;

      if (!recordId || viewingRecords.includes(recordId)) {
        return state;
      }

      return {
        ...state,
        cameraPage: {
          ...state.cameraPage,
          viewingRecords: [...viewingRecords, recordId],
        },
      };
    }

    case REMOVE_VIEWING_RECORD_ID: {
      const viewingRecords = state.cameraPage.viewingRecords || [];
      const recordId = action.payload;

      if (!recordId || !viewingRecords.includes(recordId)) {
        return state;
      }

      return {
        ...state,
        cameraPage: {
          ...state.cameraPage,
          viewingRecords: viewingRecords.filter((item) => item !== recordId),
        },
      };
    }

    // Share:
    case UPDATE_RECOVERY_SHARE_PAGE:
      return {
        ...state,
        sharePage: {
          ...state.sharePage,
          ...action.payload,
        },
      };

    case UPDATE_RECOVERY_CAMERA_TAB_OF_SHARE_PAGE:
      return {
        ...state,
        sharePage: {
          ...state.sharePage,
          cameraTab: {
            ...state.sharePage.cameraTab,
            ...action.payload,
          },
        },
      };

    case UPDATE_RECOVERY_GROUP_CAMERA_TAB_OF_SHARE_PAGE:
      return {
        ...state,
        sharePage: {
          ...state.sharePage,
          groupCameraTab: {
            ...state.sharePage.groupCameraTab,
            ...action.payload,
          },
        },
      };

    case UPDATE_RECOVERY_MEMBER_TAB_OF_SHARE_PAGE:
      return {
        ...state,
        sharePage: {
          ...state.sharePage,
          memberTab: {
            ...state.sharePage.memberTab,
            ...action.payload,
          },
        },
      };

    case RESET_RECOVERY_SHARE_PAGE:
      return {
        ...state,
        sharePage: initialState.sharePage,
      };

    default:
      return state;
  }
};

export const recoveryReducer = (state, action) => {
  const prevRootState = state[RECOVERY_KEY] || initialState;
  const newRootState = internalReducer(prevRootState, action);

  if (prevRootState === newRootState) {
    return state;
  }

  return { ...state, [RECOVERY_KEY]: newRootState };
};

export const getRecoveryState = (state) => {
  return state[RECOVERY_KEY] || initialState;
};

export const getRecoveryLivePage = (state) => getRecoveryState(state).livePage;
export const getRecoveryCameraPage = (state) =>
  getRecoveryState(state).cameraPage;

export const getRecoveryHistoryEventOfCameraPage = (state) =>
  getRecoveryCameraPage(state).historyEvent;

export const getRecoverySharePage = (state) =>
  getRecoveryState(state).sharePage;

export const getRecoveryCameraTabOfSharePage = (state) =>
  getRecoverySharePage(state).cameraTab;

export const getRecoveryGroupCameraTabOfSharePage = (state) =>
  getRecoverySharePage(state).groupCameraTab;

export const getRecoveryMemberTabOfSharePage = (state) =>
  getRecoverySharePage(state).memberTab;
